import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import AksharTransliteration from './AksharTransliteration';
import $ from 'jquery';
import AksharDeploy from './AksharDeploy';

class AksharTestTab extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/platform/cloud-akshar/test-and-deploy";
      var path1 = window.origin + "/platform/cloud-akshar/test-and-deploy/";
      if (currentPath === path || currentPath === path1) {
        $("#akshar-test-tab").addClass('active');
      } else if (currentPath.includes("/cloud-akshar/test-and-deploy/deploy")) {
        $("#akshar-deploy-tab").addClass('active');
      }
      else {
        $("#" + localStorage.getItem("last-project-settings-tab")).addClass('active')
      }
      $("#akshar-test-tab,#akshar-deploy-tab")
        .on("click", function () {
          $("#akshar-test-tab,#akshar-deploy-tab")
            .removeClass('active');
          localStorage.setItem("last-project-settings-tab", $(this)[0].id);

          $(this).addClass('active')

        })
    })();
  }
  render() {
    return (
      <Router basename={window.contextPath}>
        <div id="tabPage">
          <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

            <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
            <title> Dheeyantra | Clusters Details</title>
            {/* Font Awesome Icons */}
            <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
            {/* IonIcons */}
            <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
            <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
            {/* Theme style */}
            <link rel="stylesheet" href="assets/css/adminlte.css" />
            <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
            <link rel="stylesheet" href="assets/css/custom-style.css" />
            <link rel="stylesheet" href="assets/css/styles.css" />
            <link rel="stylesheet" href="assets/css/custom-style.css" />
            <div className="content-header" >
              <div className="container-fluid">
                <div className="row">
                  <div className="col-sm-5">
                    <h1 className="m-0 page-title">Test &amp; Deploy </h1>

                  </div>

                </div>
              </div>
            </div>
            <div className="container-fluid" style={{ marginLeft: '10px' }}>
              <div className="border-bottom"></div>
              {/* Nav tabs */}
              <div className="tab-class" >
                <ul className="nav nav-tabs border-bottom navCluster">
                  <Link to="/cloud-akshar/test-and-deploy" className="nav-item" data-toggle="tab"
                    style={{ textDecoration: 'none' }}>
                    <li className="nav-link" id="akshar-test-tab">Test</li>
                  </Link>
                  <Link to="/cloud-akshar/test-and-deploy/deploy" className="nav-item" data-toggle="tab"
                    style={{ textDecoration: 'none' }}>
                    <li className="nav-link" id="akshar-deploy-tab">Deploy</li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>
          <Switch>
            <Route path="/cloud-akshar/test-and-deploy/deploy" component={AksharDeploy}></Route>
            <Route path="/cloud-akshar/test-and-deploy" component={AksharTransliteration}></Route>
          </Switch>
        </div>
      </Router>

    );
  }
}
export default AksharTestTab;


// WEBPACK FOOTER //
// ./src/aksharUi/AksharTestTab.js